@if (chartComponent) {
<ng-container *ngComponentOutlet="chartComponent; inputs: chartInputs"></ng-container>
} @else {
<common-chart [chartCriteria]="chartCriteria"></common-chart>
}